import {
    Box,
    Button,
    FormControl, Grid, MenuItem,
    Select,
    Table, TableBody, TableCell,
    TableRow,
    Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";

function DeckFieldAssociationView({words, confirmationCallback, cancelCallback}) {

    const fields = [
        {key: 0, name: "word", displayName: "Foreign word", mandatory: true, allowDuplicates: false},
        {key: 1, name: "translation", displayName: "Translation", mandatory: true, allowDuplicates: false},
        {key: 2, name: "sentence1", displayName: "Example sentence 1", mandatory: false, allowDuplicates: false},
        {key: 3, name: "sentence_translation1", displayName: "Example sentence translation 1", mandatory: false, allowDuplicates: false},
        {key: 4, name: "sentence2", displayName: "Example sentence 2", mandatory: false, allowDuplicates: false},
        {key: 5, name: "sentence_translation2", displayName: "Example sentence translation 2", mandatory: false, allowDuplicates: false},
        {key: 6, name: "sentence3", displayName: "Example sentence 3", mandatory: false, allowDuplicates: false},
        {key: 7, name: "sentence_translation3", displayName: "Example sentence translation 3", mandatory: false, allowDuplicates: false},
        {key: 8, name: "pos", displayName: "Part of speech", mandatory: false, allowDuplicates: false},
        // {key: 5, name: "", displayName: "Synonym", mandatory: false, allowDuplicates: true},
        // {key: 6, name: "", displayName: "Translation synonym", mandatory: false, allowDuplicates: true},
        {key: 9, name: "aux", displayName: "Other", mandatory: false, allowDuplicates: true},
    ]

    const [displayedWord, setDisplayedWord] = useState(null);
    const [partIndexToKeyMapping, setPartIndexToKeyMapping] = useState(words[0].parts.map((part) => ''));
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        selectRandomWordToDisplay();
        checkForErrors(partIndexToKeyMapping);
    }, []);

    function selectRandomWordToDisplay() {
        setDisplayedWord(words[Math.floor(Math.random() * words.length)]);
    }

    function updatePartKey(partIndex, key) {
        const newMapping = partIndexToKeyMapping.map((value, index) => index === partIndex ? key : value);
        setPartIndexToKeyMapping(newMapping);
        checkForErrors(newMapping);
    }

    function checkForErrors(mapping) {
        let problematicField;
        if ((problematicField = fields.filter(field => field.mandatory).find(field => !mapping.includes(field.key))) !== undefined) {
            setErrorMessage(`The field '${problematicField.displayName}' must be selected`);
        }
        else if ((problematicField = fields.filter(field => !field.allowDuplicates).find(field => mapping.filter(key => key === field.key).length > 1)) !== undefined) {
            setErrorMessage(`Field ${problematicField.displayName} cannot appear more than once`);
        }
        else if (mapping.some(key => key === '')) {
            setErrorMessage("Please assign all fields. If some fields are redundant, select the 'Discard field' option");
        }
        else {
            setErrorMessage('');
        }
    }

    function generateMappingResponse() {
        return fields.filter(({key}) => partIndexToKeyMapping.includes(key)).map(({key, name, displayName}) => [name, displayName, partIndexToKeyMapping.indexOf(key)])
    }


    return (
        <Box>
            <Typography variant="h4" fontWeight="bold" align="center" sx={{mb: 4}}>Classify word fields</Typography>
            <Typography variant="body1">
                We need your help figuring out the purpose of each field. Below is one of the words from the deck you uploaded. Please select the purpose of each field.
            </Typography>
            <Button size="small" color="purple" onClick={selectRandomWordToDisplay}>
                Change word
            </Button>
            <FieldSelectionTable/>
            <Typography variant="body1" sx={{my: 3, fontStyle: 'italic'}}>{errorMessage}</Typography>
            <Button variant="contained"
                    color="purple"
                    disabled={errorMessage !== ''}
                    sx={{borderRadius: 3, mb: 3}}
                    onClick={() => confirmationCallback(generateMappingResponse())}
            >
                Continue
            </Button>
        </Box>
    )

    function FieldSelectionTable() {
        return (
            <Table size="small">
                <TableBody>
                    {displayedWord && displayedWord.parts.map((part, index) => <SingleRow partIndex={index} key={index}/> )}
                </TableBody>
            </Table>
        )
    }

    function SingleRow({partIndex}) {
        return (
            <TableRow>
                <TableCell>
                    <Grid container spacing={3}>
                        <Grid item xs={6} md={4}>
                            <FormControl fullWidth>
                                <Select
                                    size="small"
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    MenuProps={{
                                        disableScrollLock: true,
                                    }}
                                    value={partIndexToKeyMapping[partIndex]}
                                    onChange={(e) => updatePartKey(partIndex, e.target.value)}
                                >
                                    <MenuItem value={''}><em style={{ fontStyle: 'italic' }}>Select</em></MenuItem>
                                    {fields.map(({key, displayName, mandatory, allowDuplicates}) => (
                                        <MenuItem key={key} value={key}>{displayName}</MenuItem>
                                    ))}
                                    <MenuItem value={'discard'}>
                                        <Typography variant="body1" sx={{color: "orange", fontStyle: 'italic'}}>
                                            Discard field
                                        </Typography>
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={8} sx={{display: 'flex', alignItems: 'center'}}>
                            <Typography variant="body1">
                                {displayedWord.parts[partIndex]}
                            </Typography>
                        </Grid>
                    </Grid>
                </TableCell>
            </TableRow>
        )
    }

}

export default DeckFieldAssociationView;